

//引入
import request from "../utils/request";
const api = {
    //消防、防洪演练
    xffhylquerylist: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwywyaq/xffhylquerylist",
        });
    },

    //应急预案 轮播图
    wyaqlbtlist: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwywyaq/wyaqlbtlist",
        });
    },

    //应急预案
    yjyaquerylist: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwywyaq/yjyaquerylist",
        });
    },


    //档案资料
    dazlquerylist: function (params) {

        return request({

            method: "get",
            params,
            url: "middlescreen/api/zhwywyaq/dazlquerylist",
        });
    },
    //日常维护
    rcwxquerylist: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwywyaq/rcwxquerylist",
        });
    },

    //处置报告
    bgquerylist: function (params) {
        return request({
            method: "get",
            params,
            url: "middlescreen/api/zhwywyaq/bgquerylist",
        });
    },
}

export default api;